import * as React from 'react';
import type { SVGProps } from 'react';

const TooltipNoteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.6">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50065 1.58337C5.1354 1.58337 1.58398 5.13484 1.58398 9.50009C1.58398 13.8653 5.1354 17.4167 9.50065 17.4167C13.8659 17.4167 17.4173 13.8653 17.4173 9.50009C17.4173 5.13484 13.8659 1.58337 9.50065 1.58337ZM9.50065 15.9773C5.92903 15.9773 3.02338 13.0717 3.02338 9.50009C3.02338 5.92852 5.92903 3.02277 9.50065 3.02277C13.0723 3.02277 15.9779 5.92852 15.9779 9.50009C15.9779 13.0717 13.0722 15.9773 9.50065 15.9773ZM9.50046 4.94161C8.97144 4.94161 8.54106 5.37228 8.54106 5.90164C8.54106 6.43052 8.97144 6.8608 9.50046 6.8608C10.0295 6.8608 10.4599 6.43052 10.4599 5.90164C10.4599 5.37228 10.0295 4.94161 9.50046 4.94161ZM8.78072 9.02009C8.78072 8.62263 9.10295 8.3004 9.50042 8.3004C9.89788 8.3004 10.2201 8.62263 10.2201 9.02009V13.3383C10.2201 13.7357 9.89788 14.058 9.50042 14.058C9.10295 14.058 8.78072 13.7357 8.78072 13.3383V9.02009Z"
        fill="#131722"
      />
    </g>
  </svg>
);
export default TooltipNoteIcon;
